import { useGetApPayeesMacroList } from '@/context/services/doc_instructions/DocInstructions.service';
import { replaceMacros } from '@/features/ap_payees/components/DocInstructionMenu/Helpers/replaceMarcro';
import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { GetApPayeesMacro200ResultItem } from 'ap-openapi';
import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export const usePreviewContent = (apPayeeId: string) => {
  const { data: macroData } = useGetApPayeesMacroList(apPayeeId);
  const methods = useFormContext<InstructionEmailForm>();
  const subject = methods.watch('subject');
  const content = methods.watch('content');

  const dataMacroArray = useMemo<GetApPayeesMacro200ResultItem[]>(() => {
    return macroData?.data?.result ?? [];
  }, [macroData]);

  const processFormMacro = useCallback(
    (content: string) => {
      if (!content) return '';
      return replaceMacros(content, dataMacroArray);
    },
    [dataMacroArray]
  );

  const previewContent = useMemo(
    () => ({
      subject: processFormMacro(subject),
      content: processFormMacro(content),
    }),
    [subject, content, processFormMacro]
  );

  return {
    previewContent,
  };
};
